export default ({ editorUrl, accessToken, login, siteId, defaultDomain }) => ({
  editorUrl,
  accessToken,
  login,
  siteId,
  defaultDomain
})
